import React from "react";

import WarningIcon from "@material-ui/icons/Warning";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import "./styles.css";
import { loggedUserState } from "../../Store/atoms";
import { useSetRecoilState } from "recoil";
import { EMPTY_USER } from "../../Models/Entities";

interface IErrorProps {
  code: number;
  message: string;
  button: {
    text: string;
    route: string;
  };
  resetUser: boolean;
}

export default ({ code, message, button, resetUser }: IErrorProps) => {
  const setUser = useSetRecoilState(loggedUserState);

  const handleClick = () => {
    if (resetUser) {
      setUser(EMPTY_USER);
      localStorage.clear();
    }
  };

  return (
    <div className="error-message">
      {/* <div className="error__icon">
        <WarningIcon color="secondary" />
      </div> */}
      <div className="error__code">{code}</div>

      <div className="error__message">{message}</div>
      <Link style={{ marginTop: "2rem" }} to={button.route}>
        <Button
          style={{ fontSize: "2rem" }}
          color="primary"
          variant="contained"
          onClick={handleClick}
        >
          {button.text}
        </Button>
      </Link>
    </div>
  );
};
